export default __webpack_public_path__ + "static/media/p3-1.1b5da9da.jpg";